import { ContainerStatusEnum, ModeOfExportEnum } from "@gtpl/shared-models/common-models";

export class BookContainerDto{
    referenceNumber:string;
    expectedDeliveryDate:Date;
    saleOrderId:number;
    containerStatus:ContainerStatusEnum;
    createdUser:string;
    containerNumber:string;
    vesselSchedule:Date;
    vesselNumber:string;
    lineSeal:string;
    transporter:string;
    vehicleNumber:string;
    driverName:string;
    phoneNumber:string;
    cha:string;
    qcReport:string;
    buyerInspectionReport:string;
    vesselScheduleApproval:string;
    temperature:string;
    scrollNo:string;
    scrollDate:Date;
    portCode:string;
    shippingBillDate:string;
    shippingBillNo:string;
    examinationDate:Date;
    stuffingStartTime:string;
    stuffingCompletionTime:string;
    timeTakenForStuffing:string;
    authorisedBy:number;
    updatedUser?:string;
    containerId?:number;
    scac?:string;
    containerSize:string;
    branchCode:string;
    tempIndicatorNo:string;
    freightAfterShipment:string;
    unitId?:number;
    modeOfExport?:ModeOfExportEnum
    marksAndNo?:marksAndNoReq[]
    
    constructor(referenceNumber:string,containerSize:string, branchCode:string, tempIndicatorNo:string,freightAfterShipment:string, expectedDeliveryDate:Date, saleOrderId:number, containerStatus:ContainerStatusEnum, createdUser:string,containerNumber:string, vesselSchedule:Date, vesselNumber:string, lineSeal:string, transporter:string, vehicleNumber:string, driverName:string, phoneNumber:string,cha:string,qcReport:string,buyerInspectionReport:string,vesselScheduleApproval:string,temperature:string,scrollNo:string,scrollDate:Date,portCode:string,shippingBillDate:string, shippingBillNo:string, examinationDate:Date, stuffingStartTime:string, stuffingCompletionTime:string, timeTakenForStuffing:string, authorisedBy:number, containerId?:number, updatedUser?:string, scac?:string, unitId?:number,modeOfExport?:ModeOfExportEnum,marksAndNo?:marksAndNoReq[]){
        this.referenceNumber = referenceNumber;
        this.expectedDeliveryDate = expectedDeliveryDate;
        this.saleOrderId = saleOrderId;
        this.containerStatus = containerStatus;
        this.createdUser = createdUser;
        this.containerNumber = containerNumber;
        this.vesselSchedule = vesselSchedule;
        this.vesselNumber = vesselNumber;
        this.lineSeal = lineSeal;
        this.transporter = transporter;
        this.vehicleNumber = vehicleNumber;
        this.driverName = driverName;
        this.phoneNumber = phoneNumber;
        this.cha = cha;
        this.qcReport =qcReport;
        this.buyerInspectionReport = buyerInspectionReport;
        this.vesselScheduleApproval =vesselScheduleApproval;
        this.temperature = temperature;
        this.scrollNo = scrollNo;
        this.scrollDate = scrollDate;
        this.portCode = portCode;
        this.shippingBillDate = shippingBillDate;
        this.shippingBillNo = shippingBillNo;
        this.examinationDate = examinationDate;
        this.stuffingStartTime = stuffingStartTime;
        this.stuffingCompletionTime = stuffingCompletionTime;
        this.timeTakenForStuffing = timeTakenForStuffing;
        this.authorisedBy = authorisedBy;
        this.containerId = containerId;
        this.updatedUser = updatedUser;
        this.scac = scac;
        this.containerSize = containerSize;
        this.branchCode = branchCode;
        this.tempIndicatorNo = tempIndicatorNo;
        this.freightAfterShipment = freightAfterShipment;
        this.unitId = unitId;
        this.modeOfExport = modeOfExport
        this.marksAndNo = marksAndNo
    }
}

export class marksAndNoReq {
    saleItemId:number
    marksAndNo:string
    constructor(
        saleItemId:number,
    marksAndNo:string
    ){
        this.marksAndNo = marksAndNo
        this.saleItemId =saleItemId
    }
}